import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  filtersSummary: {
    minHeight: '41px',
    height: 'auto !important',
    backgroundColor: '#3C419A33',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  fitlersSummaryText: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    flexWrap: 'wrap',
  },
  filtersSummaryBox: {
    marginTop: '8px',
    marginBottom: '8px',
    position: 'relative',
    paddingLeft: '5px',
    left: '10px',
    marginLeft: '10px',
    width: '130px',
    fontSize: '12px',
    color: 'rgba(44, 45, 62, 0.8)',
    border: '1px solid #2C2D3E4D',
    backgroundColor: '#FFFFFF',
    display: 'inline-block',
    borderRadius: '5px',
    flexWrap: 'wrap',
  },
  filtersSummaryAllClear: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '25px',
    marginRight: '25px',
    color: '#3C419A',
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    cursor: 'pointer',
  },
  filtersSummaryBoxPracownikEgz: {
    marginTop: '8px',
    marginBottom: '8px',
    position: 'relative',
    left: '10px',
    marginLeft: '10px',
    width: '220px',
    fontSize: '12px',
    color: 'rgba(44, 45, 62, 0.8)',
    border: '1px solid #2C2D3E4D',
    backgroundColor: '#FFFFFF',
    display: 'inline-block',
    borderRadius: '5px',
    flexWrap: 'wrap',
  },
  filterbar: {
    color: 'rgba(44, 45, 62, 0.8)',
    backgroundColor: '#FFFFFF',
    width: '150px',
    margin: '5px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    height: '25px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    padding: '0px 4px',
    transform: 'translateX(-2px)',
    transition: 'width 0.5s',
    flexDirection: 'row',
  },
  filterbarExamMember: {
    color: 'rgba(44, 45, 62, 0.8)',
    backgroundColor: '#FFFFFF',
    width: '247px',
    marginTop: '8px',
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    height: '25px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    padding: '0px 4px',
    transform: 'translateX(-2px)',
    transition: 'width 0.5s',
  },
  filterCloseIcon: {
    color: 'rgba(44, 45, 62, 0.8)',
  },
  searchCloseIcon: {
    marginRight: '2px',
    width: '12px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  filtersSummaryNoSpan: {
    height: 'auto !important',
    minHeight: '45px',
    backgroundColor: '#EAEAFE',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'center',
    margin: '-20px -16px -16px -16px',
    borderBottom: '1px solid rgba(44, 45, 62, 0.2)',
  },
  fitlersSummaryTextNoSpan: {
    marginLeft: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    flexWrap: 'wrap',
  },
  filterbarNoSpan: {
    color: 'rgba(44, 45, 62, 0.8)',
    backgroundColor: '#FFFFFF',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    height: '25px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    flexDirection: 'row',
    margin: '4px',
  },
  containerNoSpan: {
    margin: '5px',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'center',
  },
}));
